import React, { useState, useEffect, useRef, useCallback } from "react";
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router";
import { css, cx } from "emotion";
import { Helmet } from "react-helmet";
import {
	mobilePanel,
	painelContent,
	scrollMobile,
	mobilePanelFooter,
	mobilePanelHeader,
	loadingStyle
} from "./style";
import {
	ROUTE_HOME,
	ROUTE_PREFIX_CREATE_OFFER_MOBILE,
	prefixFidelityAndBank,
	prefixOfferMiles,
	prefixCreditCard,
	prefixFinished,
	prefixValidateOffer,
	prefixFinishedError
} from "../../../shared/constants";
import PasswordAccess from "./steps/passwordAccess";
import PasswordRecovery from "./steps/passwordRecovery";
import PhoneRegister from "./steps/phoneRegister";
import BankInput from "./steps/bankInput";
import AgencyInput from "./steps/agencyInput";
import AccountInput from "./steps/accountInput";
import AccountTypeInput from "./steps/accountTypeInput";
import UserAccess from "./steps/userAccess";
import UserLastName from "./steps/userLastName";
import QuantMiles from "./steps/quantMiles";
import PriceMiles from "./steps/priceMiles";
import Button from "../../../../shared/button/button";
import { PanelFooter, PanelHeader, PanelContent } from "../../../../shared/create-offer/Panel";
import { useNewOffer, clearContext } from "../../../context/new-offer";
import ArrowLeft from "../../../../shared/atoms/ArrowLeft";
import { useNewOfferMobile } from "../context";
import StepCreateFinished from "./steps/StepCreateFinished";
import CreditCardNumberInput from "./steps/StepCreateCreditCard/creditCardNumberInput";
import CreditCardValidateInput from "./steps/StepCreateCreditCard/creditCardValidateInput";
import CreditCardCvvInput from "./steps/StepCreateCreditCard/creditCardCvvInput";
import CreditCardNameInput from "./steps/StepCreateCreditCard/creditCardNameInput";
import { returnUserJWT, handleFidelityNameToPath, uuid, isLatam, redirectToMilesSale } from "../../../shared/utils";
import {
	VinduloPendenteModal,
	VendaRapidaNaoElegivel,
	MediaVendasModal,
	CriarOfertaModal,
	PagamentoAntecipadoNaoElegivel,
	LatamFacialAuthRequiredModal
} from "../../../services/modals";
import StepExpectedGainCreate from "../shared/StepExpectedGainCreate";
import CreateOfferResult from "./steps/StepCreateFinished/CreateOfferResult";
import Loading from "../../../../shared/create-offer/Loading/Loading";
import ModalDynamicRange from "../../../../shared/create-offer/ModalDynamicRange/ModalDynamicRange";
import ModalDynamicBonus from "../../../../shared/create-offer/ModalDynamicBonus/ModalDynamicBonus";
import { patternOnlyNumbers } from "../../../../shared/create-offer/utils/masks";
import { publish } from "pubsub-js";
import eventType from "../../../events/eventType";
import { GOL_ACRONYM, GOL_FIDELITY_PROGRAM, Type2FA } from "../../../../../js/shared/constants";
import PhoneTwoFactor from "./steps/phoneTwoFactor";
import TwoFactorMethodSelect from "./steps/twoFactorMethodSelect";
import ModalErrorTwoFactorAuthentication from "../../../../shared/create-offer/ModalErrorTwoFactorAuthentication/ModalErrorTwoFactorAuthentication";
import ModalProcessingTwoFactorAuthentication from "../../../../shared/create-offer/ModalProcessingTwoFactorAuthentication/ModalProcessingTwoFactorAuthentication";
import Await2FAModal from "../../../../shared/create-offer/Await2FAModal/Await2FAModal";

// Debounce function
let timerId;
const debounced = (fn, delay = 250) => {
	if (timerId) clearTimeout(timerId);
	timerId = setTimeout(fn, delay);
};

const CreateOfferMobile = ({ history, match }) => {
	const {
		currentProgram,
		bankData,
		setBankData,
		banks,
		userData,
		creditCardData,
		editOffer,
		quickSaleProblem,
		setQuickSaleProblem,
		setCreditCardData,
		rankingData,
		postData,
		smilesRange,
		offerData,
		setOfferData,
		fetchPricesData,
		loyaltyData,
		setLoyaltyData,
		offerSentStatus,
		participantData,
		bonusData: { data: bonusData },
		acceptanceTerms,
		setAcceptanceTerms,
		forwardPaymentProblem,
		setForwardPaymentProblem,
		uuidCybersource,
		setUuidCybersource,
		airlineProgramsSettings,
		status2FAEnabledFeature,
		email2FAStatusValidation,
		showModalErrorTwoFactorAuthentication,
		setShowModalErrorTwoFactorAuthentication,
		twoFactorData,
		send2FACode,
		hasClickedRequest2FACode,
		setHasTriedToProceedWithout2FA
	} = useNewOffer();
	const { stepError } = useNewOfferMobile();
	const typePhoneLatam = loyaltyData.data.phoneRequiredMode;
	const editOfferRef = useRef();
	const [modals, setModals] = useState({
		vendaRapidaNaoElegivel: false,
		pagamentoAntecipadoNaoElegivel: false,
		criacaoOfertaLatam: false,
		twoFactor: false
	});
	const [modalMedia, setModalMedia] = useState({
		mediaVendas: false,
		averageMilesSuggestion: 0,
		sale: {}
	});
	const [showModalLatamFacialAuthRequired, setShowModalLatamFacialAuthRequired] = useState(isLatam(currentProgram.id));
	const [showCreditCard] = useState(
		!creditCardData.hasCreditCard &&
			currentProgram &&
			currentProgram.international === "1" &&
			(currentProgram.id == 25 ||
				currentProgram.id == 11 ||
				currentProgram.id == 10 ||
				currentProgram.id == 14)
	);

	const [optionsBank, setOptionsBank] = useState([]);

	const isQuickSale = editOffer && editOffer.quickSale;

	const isForwardPayment = editOffer && editOffer.forwardPayment;

	const [openDynamicRange, setOpenDynamicRange] = useState(false);
	const [openDynamicBonus, setOpenDynamicBonus] = useState(false);
	const [averageMilesTemp, setAverageMilesTemp] = useState(undefined);

	const { averageMiles, quant: quantOfferMiles } = offerData.data;

	const golAirlineProgramsSettings =
		airlineProgramsSettings &&
		Object.values(airlineProgramsSettings).find(
			item => item.idAirlinesProgram === GOL_FIDELITY_PROGRAM
		);

	const changeAverageSlider = async (value = averageMilesTemp) => {
		await setOfferData({
			data: { ...offerData.data, averageMiles: value }
		});
		debounced(() => fetchPricesData(quantOfferMiles, currentProgram, value), 600);
		setAverageMilesTemp(undefined);
	};

	const saveAverageSliderTemp = async value => {
		setAverageMilesTemp(value);
	};

	// TODO: Remover pagamento antecipado da regra do bônus
	const bonusValid =
		!isQuickSale && !isForwardPayment && bonusData.enabled && quantOfferMiles >= bonusData.minMiles;

	const setDynamicRange = () => {
		setOpenDynamicRange(!openDynamicRange);
	};

	useEffect(() => {
		setModals({
			...modals,
			vendaRapidaNaoElegivel: quickSaleProblem,
			pagamentoAntecipadoNaoElegivel: forwardPaymentProblem,
			vinculoPendente: participantData.isDone && participantData.hasRelationshipPendent
		});
	}, [quickSaleProblem, participantData, forwardPaymentProblem]);

	const onChangeBank = data => {
		const cpfcnpj = returnUserJWT().ssn.replace(/[^0-9]/g, "");

		setBankData({
			...bankData,
			data: { ...bankData.data, ...data, cpfcnpj }
		});
	};

	const onChangeCreditCard = data => {
		setCreditCardData({
			...creditCardData,
			data: { ...creditCardData.data, ...data }
		});
	};

	const onChangeLoyalty = data => {
		setLoyaltyData({
			...loyaltyData,
			data: { ...loyaltyData.data, ...data }
		});
	};

	const divLoading = (
		<div
			className={css`
				${loadingStyle};
			`}
		>
			<Loading width={120} height={120} />
		</div>
	);

	const buildPath = (prefix, field) => {
		return `${prefix}/${handleFidelityNameToPath(currentProgram)}${field ? `/${field}` : ""}`;
	};

	const steps = [
		{
			path: buildPath(prefixFidelityAndBank, "senha"),
			component: () => <PasswordAccess onChangeLoyalty={onChangeLoyalty} />
		},
		{
			path: buildPath(prefixValidateOffer),
			component: () => <StepCreateFinished history={history} />
		}
	];

	if (!participantData.hasManagementActive) {
		steps.splice(
			1,
			0,
			...[
				{
					path: buildPath(prefixFidelityAndBank, "banco"),
					component: () => (
						<BankInput
							step={4}
							onChangeBankData={onChangeBank}
							bankData={bankData}
							options={optionsBank}
						/>
					)
				},
				{
					path: buildPath(prefixFidelityAndBank, "agencia"),
					component: () => <AgencyInput onChangeBankData={onChangeBank} bankData={bankData} />
				},
				{
					path: buildPath(prefixFidelityAndBank, "conta"),
					component: () => (
						<AccountInput
							onChangeBankData={onChangeBank}
							bankData={bankData}
							acceptanceTerms={acceptanceTerms}
							setAcceptanceTerms={setAcceptanceTerms}
						/>
					)
				}
			]
		);
	}

	if (currentProgram?.acronym === GOL_ACRONYM && status2FAEnabledFeature) {
		steps.splice(
			1,
			0,
			...[
				{
					path: buildPath(prefixFidelityAndBank, "telefone"),
					component: () => <PhoneTwoFactor onChangeLoyalty={onChangeLoyalty} />
				},
				{
					path: buildPath(prefixFidelityAndBank, "twofactor"),
					component: () => (
						<TwoFactorMethodSelect
							airlineProgramsSettings={golAirlineProgramsSettings}
							status2FAEnabledFeature={status2FAEnabledFeature}
							email2FAStatusValidation={email2FAStatusValidation}
							offerData={offerData}
							onChangeLoyalty={onChangeLoyalty}
						/>
					)
				}
			]
		);
	}

	if (currentProgram.international === "1") {
		steps.splice(0, 0, {
			path: buildPath(prefixFidelityAndBank, "login"),
			component: () => <UserAccess onChangeLoyalty={onChangeLoyalty} />
		});
	}

	if (currentProgram.international === "1" && currentProgram.id == 14) {
		steps.splice(1, 0, {
			path: buildPath(prefixFidelityAndBank, "sobrenome"),
			component: () => <UserLastName onChangeLoyalty={onChangeLoyalty} />
		});
	}

	if (currentProgram.id === 3) {
		steps.splice(1, 0, {
			path: buildPath(prefixFidelityAndBank, "telefone"),
			component: () => (
				<PhoneRegister typePhoneLatam={typePhoneLatam} onChangeLoyalty={onChangeLoyalty} />
			)
		});
	}

	if (!isQuickSale && !isForwardPayment) {
		steps.splice(
			0,
			0,
			...[
				{
					path: buildPath(prefixOfferMiles, "quantidade"),
					component: () =>
						userData.isFetching ||
						modals.vendaRapidaNaoElegivel ||
						modals.pagamentoAntecipadoNaoElegivel ? (
							divLoading
						) : (
							<QuantMiles ref={editOfferRef} passData={data => passDataToContext(data)} />
						)
				},
				{
					path: buildPath(prefixOfferMiles, "valor"),
					component: () => (
						<PriceMiles
							setModalDynamicRange={() => setDynamicRange()}
							openModalDynamicBonus={() => setOpenDynamicBonus(true)}
							bonusValid={bonusValid}
						/>
					)
				}
			]
		);
	}

	if (showCreditCard) {
		steps.splice(
			steps.length - 1,
			0,
			...[
				{
					path: buildPath(prefixCreditCard, "numero"),
					component: () => (
						<CreditCardNumberInput
							onChangeCreditCardData={onChangeCreditCard}
							creditCardData={creditCardData}
						/>
					)
				},
				{
					path: buildPath(prefixCreditCard, "validade"),
					component: () => (
						<CreditCardValidateInput
							onChangeCreditCardData={onChangeCreditCard}
							creditCardData={creditCardData}
						/>
					)
				},
				{
					path: buildPath(prefixCreditCard, "cvv"),
					component: () => (
						<CreditCardCvvInput
							onChangeCreditCardData={onChangeCreditCard}
							creditCardData={creditCardData}
						/>
					)
				},
				{
					path: buildPath(prefixCreditCard, "nome"),
					component: () => (
						<CreditCardNameInput
							onChangeCreditCardData={onChangeCreditCard}
							creditCardData={creditCardData}
						/>
					)
				}
			]
		);
	}

	const [index, setIndex] = useState(0);

	const matchPath = `${match.params.path}/${match.params.step}`;
	const matchIndex = steps.findIndex(step => step.path === matchPath);

	const currentStep = steps[index] || {
		path: buildPath(prefixFinished),
		component: () => <CreateOfferResult typePhoneLatam={typePhoneLatam} />
	};

	useEffect(() => {
		if (matchIndex > index) {
			history.push(`${ROUTE_PREFIX_CREATE_OFFER_MOBILE}/${currentStep.path}`);
		} else if (steps[matchIndex]) {
			setIndex(matchIndex);
		} else if (
			match.params.path &&
			(match.params.path.includes(prefixFinished) ||
				match.params.path.includes(prefixFinishedError))
		) {
			setIndex(steps.length);
		}
	}, [match, history, matchIndex]);

	useEffect(() => {
		if (banks.data.length > 0) {
			// let options = [{ label: "Selecione", value: "" }];
			let options = [];
			banks.data.map(item => {
				options.push({
					label: item.name,
					value: item.idBank
				});
			});

			setOptionsBank(options);
		}
	}, [banks.data]);

	useEffect(() => {
		window.scrollTo(0, 0);
		if (!currentProgram.id) {
			history.push(ROUTE_HOME);
		} else if (currentStep.path && !currentStep.path.includes(prefixFinished)) {
			history.push(`${ROUTE_PREFIX_CREATE_OFFER_MOBILE}/${currentStep.path}`);
		}
	}, [index]);

	useEffect(() => {
		checkNextDisabled();
	}, [stepError]);

	const prev = top => {
		let stepReturning = 0;
		if (index > 0 && !top) {
			if (steps.length === 9) {
				stepReturning = index === 5 && typePhoneLatam === 1 ? 2 : 1;
			} else {
				stepReturning = index === 3 && typePhoneLatam === 1 ? 2 : 1;
			}
			setIndex(index - stepReturning);
		} else {
			history.push(ROUTE_HOME);
		}
	};

	const closeTwoFactorModal = () => {
		setModals({ ...modals, twoFactor: false });
		next(false);
	};

	const handleTwoFactorModalConfirm = () => {
		send2FACode();
		closeTwoFactorModal();
	};

	const handleTwoFactorModalCancel = () => {
		closeTwoFactorModal();
	};

	const next = useCallback(
		(showModal = true) => {
			const { fidelityName, international } = currentProgram;
			const { price: priceMiles } = offerData?.data;
			const { bankId } = bankData?.data;
			const { path: step } = currentStep;
			const { paymentDeadline } = editOffer;
			const { twoFactorAuthenticationStrategy } = loyaltyData?.data;

			const bank = bankId ? banks?.data.find(bankData => bankData.idBank === bankId)?.name : "";

			const stepIdentify = step.split("/")[2];

			publish(eventType.OFFER_CONTENT_MOBILE, {
				fidelityName,
				international,
				quantityMiles: quantOfferMiles,
				priceMiles,
				bank,
				step: stepIdentify,
				averageMiles,
				paymentDeadline,
				twoFactorAuthenticationStrategy
			});

			let nextIndex = index + 1;

			if (nextIndex === steps.length - 1) {
				if (showModal && twoFactorData.is2FAEnabled) {
					setModals({ ...modals, twoFactor: true });
					return;
				}
			}

			if (step.includes("senha") && twoFactorData.is2FAEnabled && !hasClickedRequest2FACode) {
				setHasTriedToProceedWithout2FA(true);
				return;
			}

			if (steps.length === 9) {
				if (
					typePhoneLatam === 1 &&
					nextIndex === 4 &&
					!(currentProgram?.acronym === GOL_ACRONYM && status2FAEnabledFeature)
				)
					nextIndex += 1;
			} else {
				if (typePhoneLatam === 1 && nextIndex === 2) {
					nextIndex += 1;
				}
			}
			if (nextIndex < steps.length) {
				if (steps[nextIndex].path.includes(prefixValidateOffer)) {
					if (typePhoneLatam !== 0 && currentProgram.id === 3) {
						postData();
						setIndex(nextIndex);
						return;
					}

					if (showModal && currentProgram.id === 3) {
						setModals({
							...modals,
							telefoneLatam: true
						});
					} else {
						if (
							currentProgram.id === GOL_FIDELITY_PROGRAM &&
							loyaltyData.data.twoFactorAuthenticationStrategy === Type2FA.EMAIL_REDIRECT &&
							!email2FAStatusValidation.isValidated
						) {
							nextIndex = nextIndex - 1;
						}
						postData();
						setIndex(nextIndex);
					}
				} else {
					setIndex(nextIndex);
				}
			}
		},
		[
			offerData,
			currentProgram,
			editOffer,
			currentStep,
			steps,
			prefixValidateOffer,
			bankData,
			banks,
			loyaltyData,
			quantOfferMiles,
			averageMiles
		]
	);

	const checkNextDisabled = () => {
		const hasInvalidOfferData = offerData?.data?.invalid;
		const isFetchingData = rankingData.isFetching || userData.isFetching;
		const isTypePhoneLatam = typePhoneLatam === 0;

		if (hasInvalidOfferData || (isFetchingData && isTypePhoneLatam)) {
			return true;
		}

		return stepError;
	};

	const passDataToContext = data => {
		setModalMedia(data);
	};

	const telefoneLatamConfirm = ev => {
		setModals({
			...modals,
			telefoneLatam: false
		});
		next(false);
	};

	const telefoneLatamCancel = () => {
		setModals({
			...modals,
			telefoneLatam: false
		});
	};

	const confirmMediaFn = () => {
		setModalMedia({
			...modalMedia,
			mediaVendas: false
		});
		editOfferRef.current.confirmVendasModal();
	};

	useEffect(() => {
		if (uuidCybersource) return;
		setUuidCybersource(uuid());
	}, [uuidCybersource]);

	useEffect(() => {
		if (email2FAStatusValidation.isValidated) {
			setIndex(prevIndex => prevIndex + 1);
		}
	}, [email2FAStatusValidation]);

	return (
		<>
			{uuidCybersource && (
				<Helmet>
					<script
						src={`https://h.online-metrix.net/fp/tags.js?org_id=${process.env.CS_TOKEN}&session_id=${process.env.ID_CYBERSOURCE}${uuidCybersource}`}
						type="text/javascript"
					/>
					<noscript>
						{`
				<iframe
				title='cyber'
				src=https://h.online-metrix.net/fp/tags.js?org_id=${process.env.CS_TOKEN}&session_id=${process.env.ID_CYBERSOURCE}${uuidCybersource}
				/>
				`}
					</noscript>
				</Helmet>
			)}
			<div
				className={css`
					${mobilePanel(currentStep.path.includes("/valor"))};
				`}
			>
				<PanelHeader
					className={css`
						${mobilePanelHeader}
					`}
				>
					{(!isQuickSale ||
						(isQuickSale && index > 0) ||
						!isForwardPayment ||
						(isForwardPayment && index > 0)) &&
					!currentStep.path.includes(prefixFinished) &&
					!currentStep.path.includes(prefixValidateOffer) ? (
						<div className="go-back" onClick={() => prev(true)}>
							<ArrowLeft>Voltar</ArrowLeft>
						</div>
					) : (
						<br />
					)}
					<div className="control-steps">
						<strong>Cadastro</strong>{" "}
						{index < steps.length - 1 && `${index + 1} / ${steps.length - 1}`}
					</div>
				</PanelHeader>

				<PanelContent
					className={css`
						${painelContent};
					`}
				>
					<div
						className={css`
							${scrollMobile}
						`}
					>
						{currentStep.component()}
					</div>
				</PanelContent>

				{index < steps.length - 1 ? (
					<PanelFooter
						className={css`
							${mobilePanelFooter}
						`}
					>
						{currentStep.path.includes("/valor") && <StepExpectedGainCreate />}
						<div>
							<Button className="btn-gray-md-o" onClick={() => prev(false)}>
								Voltar
							</Button>
						</div>
						<div>
							<Button className="btn-primary-md" disabled={checkNextDisabled()} onClick={next}>
								{index === steps.length - 2 ? "Concluir" : "Próximo"}
							</Button>
						</div>
					</PanelFooter>
				) : (
					!offerSentStatus.isFetching &&
					offerSentStatus.success && ( // Verificação pra não aparecer botão errado antes de terminar de carregar
						<PanelFooter
							className={cx(
								css`
									${mobilePanelFooter}
								`,
								"finished"
							)}
						>
							<NavLink
								to={`${ROUTE_HOME}`}
								onClick={() => clearContext()}
								className="btn-primary-md"
								data-action="finished-offer-home"
							>
								Ir para minhas ofertas
							</NavLink>
						</PanelFooter>
					)
				)}

				<ModalDynamicRange
					height={283}
					averageMiles={averageMiles}
					startAverage={bonusData.minAverage}
					price={bonusData.value}
					countAllowedSales={rankingData.data.countAllowedSales}
					quantMiles={quantOfferMiles}
					endAverage={bonusData.maxAverage}
					changeAverageSlider={changeAverageSlider} // changeAverageSlider
					show={openDynamicRange}
					closeModal={() => setDynamicRange()}
				/>

				{bonusValid && (
					<ModalDynamicBonus
						height={283}
						averageMiles={averageMilesTemp || averageMiles}
						startAverage={bonusData.minAverage}
						price={bonusData.value}
						countAllowedSales={rankingData.data.countAllowedSales}
						quantMiles={quantOfferMiles}
						endAverage={bonusData.maxAverage}
						minCPFs={bonusData.minCPFs}
						changeAverageSlider={saveAverageSliderTemp}
						show={openDynamicBonus}
						validRange={smilesRange}
						onClose={() => setOpenDynamicBonus(false)}
						onConfirm={() => {
							setOpenDynamicBonus(false);
							changeAverageSlider();
						}}
					/>
				)}

				<VendaRapidaNaoElegivel
					show={modals.vendaRapidaNaoElegivel}
					onConfirm={() => {
						setQuickSaleProblem(false);
						editOffer.quickSale = undefined;
						setModals({ ...modals, vendaRapidaNaoElegivel: false });
					}}
				/>
				<PagamentoAntecipadoNaoElegivel
					show={modals.pagamentoAntecipadoNaoElegivel}
					onConfirm={() => {
						setForwardPaymentProblem(false);
						editOffer.forwardPayment = undefined;
						editOffer.paymentDeadline = undefined;
						setModals({ ...modals, pagamentoAntecipadoNaoElegivel: false });
					}}
				/>
				<VinduloPendenteModal
					show={modals.vinculoPendente}
					onConfirm={() => {
						setModals({ ...modals, vinculoPendente: false });
						history.push(ROUTE_HOME);
					}}
				/>

				<MediaVendasModal
					show={modalMedia.mediaVendas}
					media={modalMedia.averageMilesSuggestion}
					percent={modalMedia.sale.percentage}
					onConfirm={confirmMediaFn}
					onCancel={() => {
						setModalMedia({
							...modalMedia,
							mediaVendas: false
						});
					}}
				/>

				<CriarOfertaModal
					show={typePhoneLatam === 0 && modals.telefoneLatam}
					onConfirm={telefoneLatamConfirm}
					onCancel={telefoneLatamCancel}
				/>

				<ModalErrorTwoFactorAuthentication
					show={showModalErrorTwoFactorAuthentication}
					onConfirm={() => setShowModalErrorTwoFactorAuthentication(false)}
				/>

				<ModalProcessingTwoFactorAuthentication show={email2FAStatusValidation.isFetching} />

				<Await2FAModal
					show={modals.twoFactor}
					onConfirm={handleTwoFactorModalConfirm}
					onCancel={handleTwoFactorModalCancel}
				/>
				<LatamFacialAuthRequiredModal
					show={showModalLatamFacialAuthRequired}
					width={'95%'}
					onCancel={redirectToMilesSale}
					onConfirm={() => setShowModalLatamFacialAuthRequired(false)}
				/>
			</div>
		</>
	);
};

export default withRouter(CreateOfferMobile);
